var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"contato-holder"},[_c('FormContact'),_c('a',{staticClass:"btn-voltar",on:{"click":function($event){return _vm.goToMain()}}},[_vm._v(" Voltar ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }